import { Injectable } from "@angular/core";

@Injectable({
    providedIn: "root",
})
export class MessengerService {
    userList:any;
    
    constructor() {}
}
